var AndroidInterface = {};

// Try to load the actual AndroidInterface...
try {
  AndroidInterface = require('AndroidInterface');
} catch (ex) {
  // ...Failing that we stick with the dummy fallback.
}

export default class AndroidStorageGateway {
  constructor(deviceState, mockAndroidInterface) {
    this.deviceState = deviceState;
    this.hasMutated = false;
    this.AndroidInterface = mockAndroidInterface || AndroidInterface;
  }

  save(key, value) {
    const data = {
      key: key,
      value: value,
    };

    if (!this.isStorageAvailable()) {
      console.error('Missing AndroidInterface, failed to store key: ' + key); // eslint-disable-line no-console
      return;
    }

    this.hasMutated = true;

    this.AndroidInterface.storageSave(JSON.stringify(data));
  }

  delete(key) {
    const data = {
      key: key,
      value: null,
    };

    if (!this.isStorageAvailable()) {
      console.error('Missing AndroidInterface, failed to delete key: ' + key); // eslint-disable-line no-console
      return;
    }

    this.hasMutated = true;

    this.AndroidInterface.storageSave(JSON.stringify(data));
  }

  getInitialState(key) {
    if (this.hasMutated) {
      throw "can't read state after it has been mutated.";
    }

    if (!this.deviceState || !this.deviceState[key]) {
      return;
    }

    return this.deviceState[key];
  }

  isStorageAvailable() {
    return this.AndroidInterface && this.AndroidInterface.storageSave;
  }
}
